import { Loading } from 'components/loading/Loading';
import { Orders } from 'pages/orders';
import React, { useEffect, useState } from 'react';
import { fetchOrders } from 'services';
import { getPageLimit, showError } from 'utils';
import styles from './index.module.scss';

const UserOrders = props => {
  const [orders, setOrders] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(true);
  const { userId } = props;
  
  const fetchOrdersFn = async () => {
    try {
      const response = await fetchOrders({
        limit: getPageLimit(),
        filter: {
          userId,
        },
      });
      setOrders(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrdersFn();
  }, []);

  if (loading) return (
    <div className={styles['loader-container']}>
      <Loading type={'mini'} />
    </div>
  );
  
  return (
    <div>
      <Orders
        {...props}
        data={orders.items}
        total={orders.total}
        selectableRows={false}
        setSelectedOrders={() => { }}
        customAPIParams={{ userId }}
      />
    </div>
  );
};

export default UserOrders;